'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { isFirefox } from '../../utils/BrowserTest';
import { isModifierPressed } from '../../utils/DomEvents';
import { toShorthandSize } from '../../utils/propTypes/tshirtSize';
import { ALIGNMENT_CLASSES, SIZE_OPTIONS } from '../CheckboxConstants';
var ToggleInputWrapper = forwardRef(function (props, ref) {
  var alignment = props.alignment,
      checked = props.checked,
      children = props.children,
      childWrapperId = props.childWrapperId,
      className = props.className,
      description = props.description,
      descriptionId = props.descriptionId,
      descriptionLayout = props.descriptionLayout,
      disabled = props.disabled,
      indicator = props.indicator,
      inline = props.inline,
      input = props.input,
      labelClassName = props.labelClassName,
      onChange = props.onChange,
      readOnly = props.readOnly,
      size = props.size,
      rest = _objectWithoutProperties(props, ["alignment", "checked", "children", "childWrapperId", "className", "description", "descriptionId", "descriptionLayout", "disabled", "indicator", "inline", "input", "labelClassName", "onChange", "readOnly", "size"]);

  var shorthandSize = toShorthandSize(size);
  return React.createElement("div", Object.assign({}, rest, {
    className: classNames(className, ALIGNMENT_CLASSES[alignment], SIZE_OPTIONS[shorthandSize], disabled && 'private-checkbox--disabled', readOnly && 'private-checkbox--readonly', inline && 'private-checkbox--inline', description && descriptionLayout === 'vertical' && 'private-checkbox--stack-contents'),
    ref: ref
  }), React.createElement("label", {
    className: classNames('private-checkbox__label', labelClassName),
    onClick: function onClick(evt) {
      if (isFirefox() && isModifierPressed(evt)) {
        onChange(Object.assign({}, evt, {
          type: 'change',
          target: {
            checked: !checked
          }
        }));
      }
    }
  }, React.createElement("span", {
    className: "private-checkbox__inner"
  }, input, indicator, children && React.createElement("span", {
    className: 'private-checkbox__text' + (shorthandSize === 'sm' ? " private-checkbox__text--small" : ""),
    id: childWrapperId
  }, children))), description && React.createElement("span", {
    className: "private-checkbox__desc",
    id: descriptionId
  }, description));
});
ToggleInputWrapper.displayName = 'ToggleInputWrapper';

if (process.env.NODE_ENV !== 'production') {
  ToggleInputWrapper.propTypes = {
    alignment: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    children: PropTypes.node,
    childWrapperId: PropTypes.string,
    className: PropTypes.string,
    description: PropTypes.node,
    descriptionId: PropTypes.string.isRequired,
    descriptionLayout: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    indicator: PropTypes.node.isRequired,
    inline: PropTypes.bool,
    input: PropTypes.node.isRequired,
    labelClassName: PropTypes.string,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    size: PropTypes.string
  };
}

export default ToggleInputWrapper;